import * as React from "react";

import * as reports from "@client/features/reports";

import * as router from "@client/router";
import * as utils from "@client/utils";

import {WeeklyMacros} from "@client/components/WeeklyMacrosTable";
import {server} from "@reactivated";

export const Reports = router.Reports.withHooks((props) => {
    const rangeForm = reports.useRangeForm(props.location.query);

    return {
        rangeForm,
    };
})
    .withTab(
        {
            name: "measurements",
            icon: "tachometer",
            title: "Measurements",
        },
        (props) => (
            <reports.Measurements profile={props.profile} rangeForm={props.rangeForm} />
        ),
    )
    .withTab(
        {
            name: "macros",
            icon: "cutlery",
            title: "Macros",
        },
        (props) => {
            const result = utils.useHMRAsync(() =>
                server.journal.reports.weekly_macros({
                    user_id: props.profile.user.id,
                }),
            );

            return <WeeklyMacros profile={props.profile} result={result} />;
        },
    )
    .withTab(
        {
            name: "exercises",
            icon: "custom-dumbbell",
            title: "Exercises",
        },
        (props) => (
            <reports.Exercises profile={props.profile} rangeForm={props.rangeForm} />
        ),
    )
    .withActions(() => [])
    .withOptions(() => ({
        isDelegatable: false,
        title: "Reports",
    }));
